import { MainScreenModule } from 'modules';

export const MainScreen = () => {
  return <MainScreenModule />;
};
